export const meetingsActionTypes = {
    SET_MEETINGS: "SET_MEETINGS",
    SET_CALENDAR_MEETINGS:"SET_CALENDAR_MEETINGS",
    SET_UPCOMING_CALENDAR_MEETINGS: "SET_UPCOMING_CALENDAR_MEETINGS",
    SET_CALENDAR_BOT_MEETINGS:"SET_CALENDAR_BOT_MEETINGS",
}